import dashboardGetCoachingSummary from './dashboard.getCoachingSummary';
import dashboardGetScores from './dashboard.getScores';
import dashboardGetReportMeta from './dashboard.getReportMeta';
import dashboardGetUserStatus from './dashboard.getUserStatus';
import dashboardGetPredicate from './dashboard.getPredicate';
import dashboardGetDebt from './dashboard.getDebt';
import dashboardGetRawData from './dashboard.getRawData';

export const getCoachingSummary = dashboardGetCoachingSummary;
export const getScores = dashboardGetScores;
export const getReportMeta = dashboardGetReportMeta;
export const getUserStatus = dashboardGetUserStatus;
export const getPredicate = dashboardGetPredicate;
export const getDebt = dashboardGetDebt;
export const getRawData = dashboardGetRawData;
